import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MediaLayout from './MediaLayout';
import Logos from './logos/index';
import Gallery from './gallery/index';
import Videos from './videos/index';

const Media: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<MediaLayout />}>
                <Route index element={<Navigate to="logos" replace />} />
                <Route path="logos" element={<Logos />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="videos" element={<Videos />} />
            </Route>
        </Routes>
    );
};

export default Media;
